




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class StatementPasscode extends Vue {
  @Prop({}) readonly passcode!: string;
  @Prop({ default: false }) readonly showAlertMessage!: boolean;

  private inputPasscode = "";
  private widthScreen = 0;

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
  }

  @Watch("inputPasscode")
  inputPasscodeChanged() {
    if (this.inputPasscode) {
      this.$emit("update:showAlertMessage", false);
    }
  }

  public SetPassCode() {
    this.$emit("update:passcode", this.inputPasscode);
  }
}
